import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { setStation } from "@/lib/cart";

export default function OrderStation() {
  const { token } = useParams();
  const [error, setError] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get(`/public/station/${token}`);
        if (cancelled) return;
        setStation(data);
        // Skip confirmation screen: land directly on the menu, station stays in cart.
        // Sprint A · Silent Welcome — passiamo `state.welcome` così Menu.jsx
        // mostra l'overlay una sola volta (poi lo clear via history.replaceState).
        nav("/menu", { replace: true, state: { welcome: true } });
      } catch {
        if (!cancelled) setError("Codice QR non valido o postazione disattivata.");
      }
    })();
    return () => { cancelled = true; };
  }, [token, nav]);

  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center p-8">
        <div className="text-bronze-600 eyebrow">QR non riconosciuto</div>
        <h1 className="mt-3 text-3xl">Ops, qualcosa non torna</h1>
        <p className="mt-2 text-ink-500 text-center max-w-sm" data-testid="qr-invalid-message">{error}</p>
        <Link to="/" className="btn-primary mt-6" data-testid="manual-select-btn">
          Seleziona manualmente
        </Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-8">
      <div className="text-ink-500" data-testid="qr-loading">Riconoscimento postazione…</div>
    </div>
  );
}
